export const DonerListWithPaggination = (state) => {
    return state?.doners?.doners;
};
export const DonerIsLoading = (state) => {
    return state?.doners?.showLoading;
};
